import { Button } from '@helvetia/components/Button'
import Input from '@helvetia/components/forms/Input'
import { Col, Row } from '@helvetia/components/layout'
import { MatchMedia } from '@helvetia/components/MatchMedia'
import Spinner from '@helvetia/components/Spinner'
import Text from '@helvetia/components/Text'
import { Field, Form, Formik } from 'formik'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { LifecycleView } from '../_components/ConnectComponent'
import { Modal } from '../_components/Modal'
import { goToHelvetiaLandingPage } from '../_utils/links'
import { LogInPresenter } from './LogIn.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: LogInPresenter
  userId: string
  onSubmit: (values) => void
}

interface State {
  localizer: string
  isLoading: boolean
  isModalOpen: boolean
}

export class LogInRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: LogInPresenter

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.state = {
      localizer: null,
      isModalOpen: false,
      isLoading: true,
    }
  }

  setInitialValues = () =>
    this.setState({
      isLoading: false,
    })

  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  showModal = () => this.setState({ isModalOpen: true })

  hideModal = () => this.setState({ isModalOpen: false })

  handleClickContinuar = values =>
    this.presenter.onLogIn(this.props.userId, values.localizer)

  render() {
    const { userId, t } = this.props
    const { isLoading, isModalOpen } = this.state
    if (isLoading) return <Spinner size="xl" />

    if (!userId) {
      this.showLoading()
      goToHelvetiaLandingPage()
      return null
    }

    if (isModalOpen)
      return (
        <Modal
          buttonText={t('buttons.accept')}
          onClose={this.presenter.onHideModalHandler}
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{t('modal.offerExpired.title')}</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{t('modal.offerExpired.title')}</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="m" as="p" color="black">
            {t('modal.offerExpired.p1')}
          </Text>
        </Modal>
      )

    return (
      <>
        <Row>
          <Col>
            <Row marginTop="xxs">
              <Text as="div" color="black" size="l">
                {t('retrieve.title')}
              </Text>
            </Row>

            <Row marginTop="xxs" alignItems="center">
              <Text as="div" color="black" size="s">
                {t('retrieve.main')}
              </Text>
            </Row>

            <Formik
              initialValues={this.state.localizer}
              onSubmit={this.handleClickContinuar}
              render={() => (
                <Form>
                  <Row marginTop="xs" marginBottom="s">
                    <Col>
                      <Field
                        component={Input}
                        name="localizer"
                        label={t('retrieve.label')}
                      />
                    </Col>
                  </Row>

                  <Row verticalGutter marginTop="xs" marginBottom="m">
                    <Col verticalGutter mobile={12} tablet={4} desktop={4}>
                      <Button primary type="submit">
                        {t('buttons.send')}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export const LogInView = withNamespaces()(withRouter(LogInRaw))
